<header>
  <nav class='navbar navbar-expand-sm  justify-content-start'>
    @if (!isUserLogged()) {
      <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
        <div class="navbar-nav ml-auto">
          @if (!isUserLogged()) {
            <input type="image" class="mr-1" src="data:image/jpeg;base64,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"
              (click)="changerLangue('en')" title="{{'NAV_BAR_TOP.ANGLAIS' | translate}}" />
          }
          @if (!isUserLogged()) {
<input type="image" class="mr-1" src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAUAAA/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAACEAAAAnUAAALlAAADaP/bAIQAAgICAgICAgICAgMCAgIDBAMCAgMEBQQEBAQEBQYFBQUFBQUGBgcHCAcHBgkJCgoJCQwMDAwMDAwMDAwMDAwMDAEDAwMFBAUJBgYJDQsJCw0PDg4ODg8PDAwMDAwPDwwMDAwMDA8MDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwM/8IAEQgAFAAeAwERAAIRAQMRAf/EAKoAAQEBAAAAAAAAAAAAAAAAAAcGCAEBAQEBAAAAAAAAAAAAAAAABgQHBRAAAAMIAwAAAAAAAAAAAAAAEAIGAAExMgMEBTYREhMRAAAEAwYHAAAAAAAAAAAAAAABEQISgwUQIUHCE7MxUWGBMgMjEgABBQEAAAAAAAAAAAAAAAAgEAGBwQIAEwABAgUDBAMAAAAAAAAAAAABABEQITFBYfCxwSBRcYEwkaH/2gAMAwEAAhEDEQAAASJtDvQtVNcRuFRMyHUsL3wVqmuI3B4WhXqWFbxLVTXEbhkTL//aAAgBAQABBQIxjHMitZWzOe9wIrWVsFTz9EVrK2YvTj//2gAIAQIAAQUCa5nrDcz1huZ6wf/aAAgBAwABBQJiwxAlhiBLDEB//9oACAECAgY/AucHB1//2gAIAQMCBj8CTUWGosNRaf/aAAgBAQEGPwJz3uNz3GrnHeZmYps7eeKZOyAyI0J1zuuNlNnbzxTJ2Sz2aMWlEelH5Q4Kgps7eeKZOyB8SqnzTmpcew//2gAIAQEDAT8hIAUfqAkk1JiSIcyCwCzHDD3mAekkfriFTGdqtEkfwfmzNpqXZf/aAAgBAgMBPyGi2WysjstlZAO01stlZD//2gAIAQMDAT8hiYQD8BhheTe9eWX/2gAMAwEAAhEDEQAAEEyYz6zf/9oACAEBAwE/ED8NwkhLxJBJJJcmK1BtZPgCIEUSQ3ANulauY/8A+h7Du0orVhn8rrlvVgdf/9oACAECAwE/EAADCi0mC5eE8NJguXiEpddqOtJguXhBpuv/2gAIAQMDAT8QVLV4IUBIdpjBZpeiR4MKWrxQqlq8EnyGersxpnuWe7L/2Q=="
               (click)="changerLangue('fr')" title="{{'NAV_BAR_TOP.FRANCAIS' | translate}}" />
          }
          @if (!isUserLogged()) {
<input type="image" class="mr-1" src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAZABkAAD/7AARRHVja3kAAQAEAAAAUAAA/+4AJkFkb2JlAGTAAAAAAQMAFQQDBgoNAAACIQAAAqQAAANPAAAEH//bAIQAAgICAgICAgICAgMCAgIDBAMCAgMEBQQEBAQEBQYFBQUFBQUGBgcHCAcHBgkJCgoJCQwMDAwMDAwMDAwMDAwMDAEDAwMFBAUJBgYJDQsJCw0PDg4ODg8PDAwMDAwPDwwMDAwMDA8MDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwM/8IAEQgAFAAeAwERAAIRAQMRAf/EALsAAAICAwAAAAAAAAAAAAAAAAADBAYCBwgBAAIDAAMAAAAAAAAAAAAAAAACAQUGAwQHEAABAwMFAQAAAAAAAAAAAAABAAIDEAQUIBESFQYWEQABAgUBBAsBAAAAAAAAAAABEQIAITESAxMQgSMFQVFhkSIyUoLiowQ1EgACAAUFAAAAAAAAAAAAAAAAMSARIaEyEPABsQITAQABBAEEAgIDAAAAAAAAAAERACExQRDwUYHhYZGhwSBx0f/aAAwDAQACEQMRAAABveI9BjO0vrrlJsGurV2PDZc2wHHnpGrTDAOlf//aAAgBAQABBQKTy4UXmYpm/JIeUIV/HNMLRt7HWThzo3ht/9oACAECAAEFAm3xcX3ZYuwXYKAtAupmPbq//9oACAEDAAEFAslZKylkprtjUaP/2gAIAQICBj8CxuV83MRHMyko/wD/2gAIAQMCBj8CQhC031H/AP/aAAgBAQEGPwJ2TLzSZVz3ux9588B2LmYeDThTl2XR/Q+r5w4DmJAcEcNOor64YzDWp8LSChBm4zG6MGH9JDhiZbc1jZ+5VG1+ldpXHTuqnQu3Jfddbwk61Fdyx//aAAgBAQMBPyESVsydosmpdp6MEyikSZOIHgxKJIQdrg0t6SgtoBOnS+GrHRqBAiWfAWC+8X4+mB59FpjMc/DBhjOv12txX//aAAgBAgMBPyGBHR4p7/R+q6J9V1z6q3ebR33MfdJgiIiLsf2h/P8A/9oACAEDAwE/ITQ6/VKM/n6ron1XVPqivnrxui3dXLg5Si+eWbRX/9oADAMBAAIRAxEAABA5yAA/n//aAAgBAQMBPxAia+k5LjS8uVXu1DVmBk2K6uALI4SaIKKmYRDLRGOwclNck4iPcG+ydoXq9C14tLnQYLNIh5ft4LeOtE456wEwTqZfBNf/2gAIAQIDAT8QITldgPKwPNEgLkiAbNWXGz27c28jAoSnsKHaE+qm1AmUGZyDe9od3DlibY5Ir//aAAgBAwMBPxCMLIgAfAQUfRBOl7HxxiFFxx2a/BSjEiI3F0dLfCcaqEZZZ20zhbvlY0w24t7bCYxO4nXbm/Yibz2hx8zGdTX/2Q=="
               (click)="changerLangue('es')" title="{{'NAV_BAR_TOP.ESPAGNOL' | translate}}" />
          }
        </div>
      </div>
    }
    @if (isUserLogged()) {
      <div class="container-fluid">
        <div class="d-flex align-items-center">
          @if (canAccessArea()) {
            <app-button
              label="Area and sites"
              variant="tertiary"
              size="small"
              [addIconLeft]="true"
              style="margin-right: 12px"
              (clicked)="router.navigate(['/area'])"
            >
              <img slot="icon-left" src="./../../assets/icon/new_icon/arrow_left.svg" />
            </app-button>
          }
        @switch (infoRoute()) {
          @case ('regions') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.REGIONS' | translate}}</h2></div>
          }
          @case ('region') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.REGION_SETUP' | translate}}</h2></div>
          }
          @case ('users') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.UTILISATEURS' | translate}}</h2></div>
          }
          @case ('sites') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.SITES' | translate}}</h2></div>
          }
          @case ('zones') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.ZONES' | translate}}</h2></div>
          }
          @case ('operators') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.OPERATORS' | translate}}</h2></div>
          }
          @case ('mysite') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'NAV_BAR_LEFT.MON_SITE' | translate}}</h2></div>
          }
          @case ('myprojects') {
            <div><app-fil-ariane></app-fil-ariane></div>
          }
          @case ('workflows') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.WORKFLOWS' | translate}}</h2></div>
          }
          @case ('workflows-region') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.WORKFLOWS_REGION' | translate}}</h2></div>
          }
          @case ('myblasts') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'NAV_BAR_LEFT.MES_TIRS' | translate}}</h2></div>
          }
          @case ('config-analysis') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.CONF_ANALYSE' | translate}}</h2></div>
          }
          @case ('dashboard') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>Dashboard</h2></div>
          }
          @case ('area-dashboard') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.AREA_DASHBOARD' | translate}}</h2></div>
          }
          @case ('user-dashboard') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.USER_DASHBOARD' | translate}}</h2></div>
          }
          @case ('setup-organization') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.SETUP_ORGANIZATION' | translate}}</h2></div>
          }
          @case ('backoffice') {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'BACKOFFICE.TITLE' | translate}}</h2></div>
          }
          @default {
            <div class="navbar-brand ms-5 mb-0 h1"><h2>{{'GLOBAL.SITE_SETUP' | translate }}</h2></div>
          }
        }
        </div>
      </div>
    }

    @if (isUserLogged()) {
      <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
        <ul class="navbar-nav ml-auto">
          @if (urlContextualisee() && !isSetupRegion() && !isUserDashboard()) {
            <li class="nav-item">
              @if (listeSites().length == 1) {
                <div class="btn-group">
                  <button id="button-basic" type="button" class="btn btn-primary2">
                    <i class="fas fa-globe-americas"></i><b>{{utilisateurService.currentSite()?.region.nom}}</b>
                    <i class="fas fa-chevron-right" style="margin-left: 10px;"></i>
                    <i class="fas fa-map-marked-alt"></i><b>{{utilisateurService.currentSite()?.nom}}</b>
                  </button>
                </div>
              }
              @if (listeSites().length > 1) {
                <div class="btn-group" dropdown #dropdown="bs-dropdown" [insideClick]="true"  (isOpenChange)="onOpenChange($event)">
                  <button id="button-basic" dropdownToggle type="button" class="btn btn-primary2 dropdown-toggle" aria-controls="dropdown-basic" style="padding-left: 10px;">
                    <i class="fas fa-globe-americas"></i><b>{{utilisateurService.currentSite()?.region?.nom}}</b>
                    <i class="fas fa-chevron-right" style="margin-left: 10px;"></i>
                    <i class="fas fa-map-marked-alt"></i><b>{{utilisateurService.currentSite()?.nom}}</b>
                  </button>
                  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic" style="max-height: 500px; overflow-y: scroll;">
                    <li role="menuitem">
                      <!--<input type="text"  id="siteFilter" #siteFilter class="form-control" name="Filter" [(ngModel)]="siteFilterQuery"  placeholder="{{'NAV_BAR_TOP.CHERCHER' | translate}}" />-->
                      <input type="text" id="siteFilter" autocomplete="off" #siteFilter class="form-control" name="Filter" [(ngModel)]="query" (keyup)="filter($event)" placeholder="{{'NAV_BAR_TOP.CHERCHER' | translate}}" />
                    </li>
                    @for (site of listeSites_filtred(); track site; let i = $index) {
                      <li role="menuitem">
                        @if (i == 0) {
                          <a class="dropdown-item nom-region" style="cursor:default!important;">{{site?.groupByNomRegion}}</a>
                        }
                        @if (i == 0) {
                          <a class="dropdown-item" (click)="definirSiteEnCours(site);dropdown.hide()">{{site?.nom}}</a>
                        }
                        @if ( i > 0) {
                          @if (i > 0 && listeSites_filtred()[i-1].groupByNomRegion != site?.groupByNomRegion) {
                            <a class="dropdown-item nom-region" style="cursor:default!important;">{{site?.groupByNomRegion}}</a>
                          }
                          @if (i > 0 && listeSites_filtred()[i-1].groupByNomRegion != site?.groupByNomRegion) {
                            <a class="dropdown-item" (click)="definirSiteEnCours(site);dropdown.hide()">{{site?.nom}}</a>
                          }
                          @if (i > 0 && listeSites_filtred()[i-1].groupByNomRegion == site?.groupByNomRegion) {
                            <a class="dropdown-item" (click)="definirSiteEnCours(site);dropdown.hide()">{{site?.nom}}</a>
                          }
                        }
                      </li>
                    }
                  </ul>
                </div>
              }
            </li>
          }
          @if (isSetupRegion()) {
            <li class="nav-item">
              <div class="btn-group" dropdown #dropdown="bs-dropdown" [insideClick]="true"  (isOpenChange)="onOpenChangeRegion($event)">
                <button id="button-basic" dropdownToggle type="button" class="btn btn-primary2 dropdown-toggle" aria-controls="dropdown-basic" style="padding-left: 10px;">
                  <i class="fas fa-globe-americas"></i><b>{{utilisateurService.currentRegionForSetupRegion.nom}}</b>
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic" style="max-height: 500px; overflow-y: scroll;">
                  <li role="menuitem">
                    <input type="text" id="siteFilter" autocomplete="off" #siteFilter class="form-control" name="Filter" [(ngModel)]="query" (keyup)="filterRegions($event)" placeholder="{{'NAV_BAR_TOP.CHERCHER' | translate}}" />
                  </li>
                  @for (region of listeRegions_filtred(); track region; let i = $index) {
                    <li role="menuitem">
                      <a class="dropdown-item"  (click)="definirRegion(region);dropdown.hide()">{{region?.nom}}</a>
                    </li>
                  }
                </ul>
              </div>
            </li>
          }
          @if (isUserDashboard()) {
            <li class="nav-item">
              <div class="btn-group" dropdown #dropdownOrg="bs-dropdown" [insideClick]="true" (isOpenChange)="onOpenChangeOrganization($event)">
                <button id="button-org" dropdownToggle type="button" class="btn btn-primary2 dropdown-toggle" aria-controls="dropdown-org" style="padding-left: 10px;">
                  <i class="fas fa-building"></i><b>{{selectedOrganization()?.name}}</b>
                </button>
                <ul id="dropdown-org" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-org" style="max-height: 500px; overflow-y: scroll;">
                  <li role="menuitem">
                    <input type="text" id="orgFilter" autocomplete="off" #orgFilter class="form-control" name="Filter" [(ngModel)]="query" (keyup)="filterOrganizations($event)" placeholder="{{'NAV_BAR_TOP.CHERCHER' | translate}}" />
                  </li>
                  @for (org of organizations_filtered(); track org; let i = $index) {
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="selectOrganization(org);dropdownOrg.hide()">{{org?.name}}</a>
                    </li>
                  }
                </ul>
              </div>
            </li>
          }
        </ul>
        <ul class="navbar-nav ml-auto">
          <!-- Signalement de bug : dans la barre plutôt que flottant, pour ne rien recouvrir -->
          <li class="nav-item" *showIfHasRole="'sys_admin'" data-bug-report-trigger
            style="margin-left: 1.5rem; display: flex; align-items: center;"
            [title]="(bugReport.picking() ? 'BUG_REPORT.PICK_HINT' : 'BUG_REPORT.BUTTON') | translate">
            <app-button
              variant="primary"
              size="small"
              [addIconLeft]="true"
              [state]="bugReport.picking() ? 'pressed' : 'default'"
              [ariaLabel]="(bugReport.picking() ? 'BUG_REPORT.CANCEL_PICKING' : 'BUG_REPORT.BUTTON') | translate"
              [ariaPressed]="bugReport.picking()"
              (clicked)="bugReport.toggle()">
              <img slot="icon-left" src="assets/icon/new_icon/flag.svg" alt="" />
            </app-button>
          </li>
          <li class="nav-item" style="margin-left: 1.5rem; margin-right: 1.5rem; display: flex; align-items: center;">
            <app-button
              variant="primary"
              size="small"
              [addIconLeft]="true"
              (clicked)="navigateToOurProducts()">
              <img slot="icon-left" src="assets/icon/new_icon/floating_buttons.svg" alt="" />
            </app-button>
          </li>
          <li class="nav-item" style="margin-right: 1rem;">
            <div class="btn-group" dropdown>
              <button id="button-basic" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                aria-controls="dropdown-basic">
                <!-- <i class="fas fa-user"></i><b>{{utilisateurService.utilisateur?.prenom}} {{utilisateurService.utilisateur?.nom}}</b> -->
                <i class="fas fa-user"></i><b>{{userProfile()?.firstName}} {{userProfile()?.lastName}}</b>
              </button>
              <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="ouvrirFenetreLangue()">{{'NAV_BAR_TOP.CHANGER_LANGUE' | translate}}</a></li>
                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="ouvrirFenetreMdp()">{{'NAV_BAR_TOP.CHANGER_MDP' | translate}}</a></li>
                <li role="menuitem"><a class="dropdown-item" href="mailto:{{emailSupport()}}">{{'NAV_BAR_TOP.CONTACT_SUPPORT' | translate}}</a></li>
                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="showProfile()">{{'NAV_BAR_TOP.PROFILE' | translate}}</a></li>
                <li role="menuitem" *showIfHasRole="'support'"><a class="dropdown-item" href="javascript:void(0);" (click)="showBackoffice()">{{'NAV_BAR_TOP.BACKOFFICE' | translate}}</a></li>
                <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="logout()">{{'NAV_BAR_TOP.DECONNEXION' | translate}}</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    }
  </nav>
</header>
@if (isUserLogged() && !router.url.includes('/blasts')) {
  <div class="separation"></div>
}
